import React, {MouseEvent, useContext, useCallback} from 'react';
import {
    Button,
    DropDownV2Context,
    Icon,
    PriorityIcon
} from '@priority-software/priority-style-react';
import {DropdownValueType} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';

type TriggerProps = {
    value: DropdownValueType;
    disabled?: boolean;
    dataTestId?: string;
};

export const TriggerButton = ({disabled, value, dataTestId}: TriggerProps) => {
    const {isOpen, openDropdown, closeDropdown} = useContext(DropDownV2Context);

    const handleToggle = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        },
        [isOpen, closeDropdown, openDropdown]
    );

    return (
        <Button
            disabled={disabled}
            onClick={e => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                handleToggle(e);
            }}
            skin="secondary"
            suffixIcon={<Icon icon={isOpen ? PriorityIcon.arrowUp : PriorityIcon.arrowBottom} />}
            dataTestId={dataTestId}
        >
            {value}
        </Button>
    );
};
